import { Box, omitThemingProps, RadioGroup, RadioGroupProps, RadioProps, useRadio, useRadioGroupContext } from '@chakra-ui/react';
import { ChangeEvent, FC } from 'react';

import { useId } from '../../hooks/use-id';

export const RadioChipGroup: FC<RadioGroupProps> = ({ children, ...rest }) => {
	return (
		<RadioGroup p={2} border="1px solid" borderColor="border.input" borderRadius="md" display="inline-flex" columnGap={1} {...rest}>
			{children}
		</RadioGroup>
	);
};

export const RadioChip: FC<RadioProps> = (props) => {
	const group = useRadioGroupContext();
	const { onChange: onChangeProp, value: valueProp } = props;

	const { children, isDisabled = group?.isDisabled, isFocusable = group?.isFocusable, ...rest } = omitThemingProps(props);

	let isChecked = props.isChecked;

	if (group?.value != null && valueProp != null) {
		isChecked = group.value === valueProp;
	}

	let onChange = onChangeProp;

	if (group?.onChange && valueProp != null) {
		onChange = (event: ChangeEvent<HTMLInputElement>) => {
			onChangeProp?.(event);
			group.onChange(event);
		};
	}

	const { getInputProps, getRadioProps } = useRadio({
		...rest,
		isChecked,
		isFocusable,
		isDisabled,
		onChange,
		name: props?.name ?? group?.name,
	});

	const input = getInputProps();
	const checkbox = getRadioProps();

	const id = useId('checkbox');

	return (
		<Box as="label">
			<input aria-labelledby={id} {...input} />
			<Box
				{...checkbox}
				color="primary.fgStrong"
				cursor="pointer"
				borderRadius="sm"
				id={id}
				px={2}
				py={0.5}
				transition="background-color 0.2s ease-in-out"
				_checked={{
					bgColor: 'primary.bg',
					color: 'white',
				}}
			>
				{children}
			</Box>
		</Box>
	);
};
